let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3gMOM")).then(() => parcelRequire('5tuUc'));